const PSOrientationBaseController = require('./PSOrientationBaseController');

cc.Class({
    extends: PSOrientationBaseController,

    properties: {
        landscapeDesktop: {
            type: cc.Node,
            default: null,
        },
        portraitDesktop: {
            type: cc.Node,
            default: null,
        },
        landscapeMobile: {
            type: cc.Node,
            default: null,
        },
        portraitMobile: {
            type: cc.Node,
            default: null,
        }
    },

    onLoad () {
        this._super();
        this.isLoaded = true;

        if (this.lastConfig) {
            this._layout(this[this.lastConfig]);
        }
    },

    onLandscapeMobile () {
        this.lastConfig = 'landscapeMobile';
        this._layout(this.landscapeMobile);
    },

    onPortraitMobile () {
        this.lastConfig = 'portraitMobile';
        this._layout(this.portraitMobile);
    },

    onLandscapeDesktop () {
        this.lastConfig = 'landscapeDesktop';
        this._layout(this.landscapeDesktop);
    },

    onPortraitDesktop () {
        this.lastConfig = 'portraitDesktop';
        this._layout(this.portraitDesktop);
    },

    _layout (node) {
        if (!this.isLoaded) {
            return;
        }

        if (this.landscapeDesktop) {
            this.landscapeDesktop.active = false;
        }
        if (this.landscapeMobile) {
            this.landscapeMobile.active = false;
        }

        if (this.portraitDesktop) {
            this.portraitDesktop.active = false;
        }
        if (this.portraitMobile) {
            this.portraitMobile.active = false;
        }

        if (node) {
            node.active = true;
        }
    }

});
